/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import BoxOpcionais from './BoxOpcionais'
import ModalPagamentoOpcionais from './ModalOpcionais/ModalPagamentoOpcionais'
import { STATUS_VALIDOS_ASSINATURAS_OPCIONAIS, ADICIONAR, EVENTOS_PIXEL } from './constantsCardOpcionais'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS } from '../../constants'
import { useOpcionais } from '../../contexts/OpcionaisContext'
import { useGlobal } from '../../contexts/GlobalContext'
import { isEmptyObject, objetoTemPropriedade } from '../../utils/helpers/helpers'
import { contarOpcionaisComprados } from '../../utils/helpers/helpersOpcionais'
import { formatMesPorExtenso } from '../../utils/formatter/formatter'
import ReactPixel from 'react-facebook-pixel'
import WrapperComponent from './WrapperComponent'

const estiloParagrafo = `
  p {
    margin-top: 0;
  }
`

const OpcionaisWrapper = styled.div`
  .botoes {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    button {
      width: 100%;
    }
  }

`

const Titulo = styled.h2`
  margin-bottom: 10px;
`

const BoxTitulo = styled.div`
  ${estiloParagrafo}
  .wrappers {
    padding-top: 10px;
  }
`

const CardOpcionais = () => {
  const { dadosGlobaisAssociado } = useGlobal()
  const {
    dadosOpcionais,
    fetchDadosOpcionais,
    limparStateOpcionais,
    opcionaisSelecionados,
    setMesOpcional
  } = useOpcionais()
  const [ toggleModalPagamento, setToggleModalPagamento ] = useState( false )
  const [ botaoCompraHabilitadoPodeComprar, setBotaoCompraHabilitadoPodeComprar ] = useState( false )
  const [ botaoCompraHabilitadoOpcionalSelecionado, setBotaoCompraHabilitadoOpcionalSelecionado ] = useState( false )

  useEffect( () => {
    fetchDadosOpcionais()
  }, [] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && objetoTemPropriedade( dadosGlobaisAssociado, 'assinaturas' ) ) {
      const [ dadosModalidade ] = dadosGlobaisAssociado.modalidades
      const { 'mesTagAtual': mesTAGAtual } = dadosModalidade
      if ( mesTAGAtual && mesTAGAtual.mes ) {
        const mesPorExtenso = formatMesPorExtenso( dadosModalidade.mesTagAtual.mes + 1 ).toLowerCase()
        setMesOpcional( mesPorExtenso )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( dadosOpcionais.opcionais ) {
      const qtdeOpcionaisComprados = contarOpcionaisComprados( dadosOpcionais.opcionais.produtos )

      setBotaoCompraHabilitadoPodeComprar( qtdeOpcionaisComprados < dadosOpcionais.limitePorUsuario )
    }
  }, [ dadosOpcionais ] )

  useEffect( () => {
    const temOpcionaisSelecionados = Boolean( opcionaisSelecionados.length )
    setBotaoCompraHabilitadoOpcionalSelecionado( temOpcionaisSelecionados )
  }, [ opcionaisSelecionados ] )

  useEffect( () => {
    const id = 'opcional'
    const yOffset = -50
    const element = document.getElementById( id )

    if ( window.location.href.includes( `#${id}` ) && element ) {
      const yCurrentOffset = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo( { 'top': yCurrentOffset, 'behavior': 'auto' } )
    }
  } )

  const assinaturas = dadosGlobaisAssociado.assinaturas.filter( assinatura => STATUS_VALIDOS_ASSINATURAS_OPCIONAIS.includes( assinatura.status ) )
  const isCuradoria = assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_CURADORIA.visualizacao )
  const isIneditos = assinaturas.find( assinatura => assinatura.modalidade === MODALIDADE_INEDITOS.visualizacao )
  const isCombo = isCuradoria && isIneditos

  function filterByModalidade( produto ) {
    if ( isCombo ) {
      return true
    }
    if ( isCuradoria ) {
      return produto.categoriaId === 1
    }
    if ( isIneditos ) {
      return produto.categoriaId === 2
    }
    return false
  }
  if ( !isEmptyObject( dadosOpcionais ) && objetoTemPropriedade( dadosOpcionais, 'opcionais' ) && dadosOpcionais.opcionais.produtos.length ) {
    // eslint-disable-next-line quote-props
    const { opcionais: { produtos } } = dadosOpcionais
    const uniqueInfoProduto = isCombo
      ? [ ...new Map( produtos.map( item => [ item.id, item ] ) ).values() ]
      : produtos

    return (
      <OpcionaisWrapper>
        {Boolean( toggleModalPagamento ) && (
          <ModalPagamentoOpcionais
            showModal={ toggleModalPagamento }
            toggleModal={ () => {
              limparStateOpcionais()
              setToggleModalPagamento( !toggleModalPagamento )
            } }
          />
        )}

        <Card
          className="card"
          largura="100%"
          margin="0"
          padding={ StyleGuide.isMobile() ? '20px' : '30px' }
        >
          {uniqueInfoProduto.length && uniqueInfoProduto.some( filterByModalidade ) ? (
            <>
              <BoxTitulo>
                <Titulo>{dadosOpcionais.opcionais.titulo}</Titulo>

                <div className="wrappers">
                  {uniqueInfoProduto
                    .filter( filterByModalidade )
                    .map( ( opcional, index ) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={ index }>
                        <WrapperComponent opcional={ opcional } />

                        <BoxOpcionais
                          index={ index + 1 }
                          opcional={ opcional }
                        />
                      </div>
                    ) )}
                </div>
              </BoxTitulo>

              {Boolean( botaoCompraHabilitadoPodeComprar ) && (
                <div className="botoes">
                  <Button
                    disabled={ !botaoCompraHabilitadoOpcionalSelecionado }
                    onClick={ () => {
                      ReactPixel.trackCustom( EVENTOS_PIXEL.ADICIONAR_NA_CAIXINHA )
                      setToggleModalPagamento( !toggleModalPagamento )
                    } }
                    testId="botao-comprar-opcional"
                  >
                    {ADICIONAR}
                  </Button>
                </div>
              )}
            </>
          ) : (
            null
          )}
        </Card>
      </OpcionaisWrapper>
    )
  }

  return null
}

CardOpcionais.propTypes = {
  'mesOpcional': string
}

CardOpcionais.defaultProps = {
  'mesOpcional': null
}

export default CardOpcionais
